var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 22.0001H6C5.20435 22.0001 4.44129 21.684 3.87868 21.1214C3.31607 20.5588 3 19.7957 3 19.0001V5.00006C3 4.20441 3.31607 3.44135 3.87868 2.87874C4.44129 2.31614 5.20435 2.00006 6 2.00006H20C20.2652 2.00006 20.5196 2.10542 20.7071 2.29295C20.8946 2.48049 21 2.73485 21 3.00006V21.0001C21 21.2653 20.8946 21.5196 20.7071 21.7072C20.5196 21.8947 20.2652 22.0001 20 22.0001ZM19 20V18.0001H6C5.73479 18.0001 5.48043 18.1055 5.29289 18.293C5.10535 18.4805 5 18.7349 5 19.0001C5 19.2653 5.10535 19.5196 5.29289 19.7071C5.48043 19.8947 5.73479 20 6 20H19ZM5 16.1701C5.313 16.0601 5.65 16.0001 6 16.0001H19V4.00006H6C5.73479 4.00006 5.48043 4.10542 5.29289 4.29295C5.10535 4.48049 5 4.73485 5 5.00006V16.1701ZM12 10C11.4696 10 10.9609 9.78937 10.5858 9.4143C10.2107 9.03922 9.99997 8.5305 9.99997 8.00003C9.99997 7.46963 10.2107 6.96092 10.5858 6.58585C10.9609 6.21077 11.4696 6.00006 12 6.00006C12.5304 6.00006 13.0391 6.21077 13.4142 6.58585C13.7893 6.96092 14 7.46963 14 8.00003C14 8.5305 13.7893 9.03922 13.4142 9.4143C13.0391 9.78937 12.5304 10 12 10ZM9 14C9 13.2044 9.31605 12.4414 9.8787 11.8787C10.4413 11.3161 11.2043 11 12 11C12.7957 11 13.5587 11.3161 14.1213 11.8787C14.6839 12.4414 15 13.2044 15 14H9Z",
    fill: "#1F2937"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contacts_icon.e6d5cc8a6ce7c6f5333d3baecc9a6768.svg";
export { ForwardRef as ReactComponent };